import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const FacebookCirOut24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.facebookFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm0 1.198C6.815 2.198 2.198 6.815 2.198 12.5S6.815 22.802 12.5 22.802 22.802 18.185 22.802 12.5 18.185 2.198 12.5 2.198zm1.285 4.552l1.56.008v1.97h-1.362c-.228 0-.715.104-.715.552v1.46h2.107l-.325 2.03h-1.782v5.48H11.17v-5.48H9.625v-2.03h1.545V9.16c0-.94.486-2.41 2.615-2.41z"
      fillRule="evenodd"
    />
  </svg>
);

export default FacebookCirOut24;
